// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
    // production: true,
    production: false,
    apiUrl: 'https://api.clubsandwich.mx/public/api/v1/',
    apiLoginUrl: 'https://api.clubsandwich.mx/public/api/login_check',
    apiPublicUrl: 'https://api.clubsandwich.mx/public/', //for the use of images, assets etc.
    // apiUrl: 'http://127.0.0.1:8000/api/v1/',
    // apiLoginUrl: 'http://127.0.0.1:8000/api/login_check',
    // apiPublicUrl: 'http://127.0.0.1:8000/', //for the use of images, assets etc.
};



// WEBPACK FOOTER //
// /Users/cricketmon/Sites/clubsandwichadmin/src/environments/environment.ts